<template>
	<div class="flex flex-col">
		<!-- История -->
		<ul class="mb-3 px-4">
			<li
				v-for="(value, i) in values"
				:key="i"
				class="border-grey-lite flex items-center justify-between border-b border-solid py-3"
				data-test-name="history-item"
				@click="$emit('select', value)"
			>
				<span class="font-sirius text-base font-medium">
					{{ value }}
				</span>
				<span
					class="history-arrow h-6 w-6 shrink-0 bg-contain bg-no-repeat"
				></span>
			</li>
		</ul>

		<!-- Кнопка очистки -->
		<div class="px-4">
			<button
				class="flex h-9 w-full items-center justify-center"
				data-testid="history-btn-clear"
				@click="$emit('clear')"
			>
				<span
					class="history-refresh mr-2 h-4 w-4 shrink-0 bg-contain bg-no-repeat"
				></span>
				<span class="font-sirius text-blue-accent text-base">
					{{ $t('search.clearHistory') }}
				</span>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SearchHistory',
	props: {
		values: {
			type: Array,
			default: () => []
		}
	},
	emits: ['select', 'clear']
};
</script>

<style lang="scss" scoped>
.history {
	&-arrow {
		background-image: url('@/assets/icons/arrow-up-left.svg');
	}

	&-refresh {
		background-image: url('@/assets/icons/refresh.svg');
	}
}
</style>
